export const configuration = {
  serviceUrls: {
    maise: 'https://maise.products.cimpress.io',
    msx: 'https://merchandising-site-experience.prod.merch.vpsvc.com',
    merchantProductOrchestration: 'https://merchant-orchestration-api.products.cimpress.io',
    urlMetadata: 'https://url-metadata.prod.merch.vpsvc.com',
  },
  requestor: 'fragment-pdp-toast',
  mcpAuth: {
    mcpClientId: process.env.MCP_CLIENT_ID,
    mcpClientSecret: process.env.MCP_CLIENT_SECRET,
  },
  redis: {
    host: process.env.REDIS_HOST!,
    port: parseInt(process.env.REDIS_PORT!),
  },
};
